import { Participant } from '@/interfaces/participant'
import { Utils } from '@/lib/utils'

export const useParticipant = () => {
  const getLastName = (participant: Participant, isShort = false) => {
    if (!isShort) {
      participant.lastName
    }

    return `${participant.lastName[0].toUpperCase()}.`
  }

  const getAvatarLink = (participant: Participant): string => {
    const avatar = participant.files.find((file) => file.type === 'avatar')

    if (avatar === undefined) {
      return ''
    }

    return Utils.buildImageLink(avatar.bucket, avatar.objectName)
  }

  return {
    getLastName,
    getAvatarLink,
  }
}
